import React, { useState, useEffect } from 'react';
import "./OperationFilters.css";
import ExecuteAxios from "../../../../Components/ExecuteAxios/ExecuteAxios";
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import InputField from 'Components/Input/InputField';
import Button from 'Components/Button/Button';
import Panel from 'Components/Panel/Panel';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import useDebouncedValue from 'Components/UseDebouncedValue/useDebouncedValue';

const OperationFilters = ({
    onUpdateReloadListOperation,
    onUpdateOperations,
    onUpdateClassificationIdSelected,
    onUpdateOperationIdSelected,
    operationIdSelected,
    classificationIdSelected,
    supplierIdSelected,
    reloadListOperation
}) => {

    const [isActive, setIsActive] = useState('S');
    const [classifications, setClassifications] = useState(null);
    const [dsOperation, setDsOperation] = useState(null);
    const debouncedDsOperation = useDebouncedValue(dsOperation);

    useEffect(() => {
        const fetchData = async () => {
            const classifications = await ExecuteAxios.api('get', '/classification/get-active-classification-list/');
            setClassifications(classifications);
        };

        fetchData();
    }, []);


    useEffect(() => {
        filterOperation()
    }, [isActive, classificationIdSelected, debouncedDsOperation, supplierIdSelected]);

    const PanelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '20%',
        maxHeight: '20%',
        borderBottom: '2px solid rgb(204, 204, 204)'
    };

    useEffect(() => {
        if (!reloadListOperation) {
            return;
        }
        onUpdateReloadListOperation(false)
        filterOperation();
    }, [reloadListOperation])

    async function filterOperation() {
        const parameters = {
            classificationId: classificationIdSelected,
            isActive: isActive,
            supplierId: (supplierIdSelected && supplierIdSelected.length === 1 ? supplierIdSelected[0] : null),
            dsOperation: dsOperation
        };
        const operations = await ExecuteAxios.api('get', `/operation/get-operation-grid/`, { params: parameters })
        onUpdateOperations(operations);
        RemoveIdsNotFound.remove(operations, onUpdateOperationIdSelected, operationIdSelected)
    }

    function isActiveSetter() {
        return setIsActive(isActive === 'S' ? 'N' : 'S')
    }

    const classificationOptions = OptionsDataByAttributePath(classifications, ['description'], null, false)

    return (
        <>
            <Panel style={PanelListStyle}
                titlePage={'Filtros operações'}
                canViewCRUD={true}
            >
                <LoadingIndicator loaded={true}>
                    <div id='first-colum-filter-operation'>
                        <div id='filter-atributtes'>
                            <div id='operation-filter'>
                                <span className='span-operation-filter' style={{ whiteSpace: 'nowrap'}}>Somente ativos</span>
                                <InputField
                                    setAttribute={(event) => isActiveSetter(event)}
                                    value={isActive}
                                    checked={isActive === 'S'}
                                    readOnly={false}
                                    disabled={false}
                                    type="checkbox"
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>

                            <div id='operation-filter'>
                                <span className='span-operation-filter'>Classificação</span>
                                <ComboBox setAttribute={onUpdateClassificationIdSelected}
                                    optionsData={classificationOptions}
                                    style={{ minWidth: '120px', cursor: 'pointer', width: '100%' }}
                                    value={classificationIdSelected}
                                    defaultValue={classificationIdSelected}
                                />
                            </div>

                            <div id='operation-filter'>
                                <span className='span-operation-filter'>Operação</span>
                                <InputField
                                    setAttribute={(event) => setDsOperation(event)}
                                    value={dsOperation}
                                    readOnly={false}
                                    disabled={false}
                                    style={{ cursor: 'pointer', width: '100%', minWidth: '120px' }}
                                />
                            </div>
                        </div>
                    </div>
                </LoadingIndicator>
            </Panel>
        </>
    );
}
export default OperationFilters;